module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_osaka-99578aa145e47d50cbd272232a3f836c.png";